export default () => {
    return [
        {
            path: '/riepilogoMonths',
            name: 'riepilogoMonths',
            component: () => import('./views/riepilogoMonths.vue'),
        },
    ];
};
